import { entraSettings } from "./entra-settings.js";
export const nativeAccountKey = "pirdy.native-account.v1";
export function nativeAuthenticationEnabled(config) { return config?.nativeAuthentication?.enabled === true; }
export function nativeAuthSettings(config, origin) {
  if (!nativeAuthenticationEnabled(config)) throw new Error("Direct sign-in is not enabled.");
  const options = entraSettings(config, origin), api = new URL(config.apiBaseUrl);
  if (api.protocol !== "https:" || api.username || api.password || api.search || api.hash)
    throw new Error("A secure sign-in service is required.");
  return { ...options, auth: { ...options.auth, authority: options.auth.authority.replace(/\/v2\.0\/?$/, "/") },
    customAuth: { challengeTypes: ["password", "oob", "redirect"], authApiProxyUrl: api.href.replace(/\/$/, "") + "/v1/sign-in/native/" },
    system: { ...options.system, loggerOptions: { piiLoggingEnabled: false, loggerCallback: () => {} } } };
}
export async function createNativeAuthClient(config, origin) {
  const { CustomAuthPublicClientApplication } = await import("@azure/msal-browser/custom-auth");
  return CustomAuthPublicClientApplication.create(nativeAuthSettings(config, origin));
}
export function nativeAccount(client, expectedId) {
  const accounts = client.getAllAccounts();
  if (accounts.length !== 1 || (expectedId && accounts[0].homeAccountId !== expectedId))
    throw new Error("Choose your Pirdy account again to continue securely.");
  const result = client.getCurrentAccount();
  if (!result.isCompleted?.() || result.data?.getAccount().homeAccountId !== accounts[0].homeAccountId)
    throw new Error("Sign in to your Pirdy account again.");
  return result.data;
}
